enum SortParamsEnum {
    ASC = 'asc',
    DESC = 'desc',
}

export default SortParamsEnum;
